/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A free application can still require time to evaluate, document and teach. Count the repetitive steps you would gain or lose: downloading files, checking exported copies, explaining a new interface and fixing mismatches. For a single personal sheet, that overhead may be small. For a team passing workbooks between several systems, it can outweigh a difference in software price.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费应用也需要评估、记录和培训时间。应计算可能增加或减少的重复步骤，包括下载文件、检查导出副本、解释新界面和修复差异。对于个人小表格，这些成本可能很低；对于在多个系统之间交换文件的团队，它们可能比软件价格差异更重要。`)
};

/**
* | output |
* | --- |
* | "A free application can still require time to evaluate, document and teach. Count the repetitive steps you would gain or lose: downloading files, checking exp..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_0 as "gc.search_guides.gridcraft_vs_excel.sections.6.paragraphs.0" }